<template>
  <ul class="why-us-section__list">
    <li
      v-for="item in $options.consts.SECTION_ITEMS"
      :key="item.icon"
      class="why-us-section__item"
    >
      <a-icon
        :icon="item.icon"
        width="auto"
        height="auto"
        :no-hover="true"
        :original="true"
        class="why-us-section__item-logo"
      />

      <div class="why-us-section__item-info">
        <h3
          class="why-us-section__item-title"
          :style="`color: ${item.titleColor};`"
        >
          {{ item.title }}
        </h3>
        <p class="why-us-section__item-description text-caption">
          {{ item.description }}
        </p>
      </div>
    </li>
  </ul>
</template>

<script>
import AIcon, { ICON } from 'shared/AIcon/index.vue'

export default {
  name: 'HomepageWhyUsSectionList',
  components: { AIcon },
  consts: {
    SECTION_ITEMS: [
      {
        icon: ICON.TARGET_AUDIENCE,
        title: 'Target Audience',
        titleColor: '#009acf',
        description:
          'Dive into the Heart of the Financial World, Engaging with Professionals and Individual Market Players.'
      },
      {
        icon: ICON.INDUSTRY_AUTHORITY,
        title: 'Industry Authority',
        titleColor: '#00cfac',
        description:
          "Enhance Your Brand's Presence with Expertise That Appeals to Both Leaders and Clients."
      },
      {
        icon: ICON.FINTECH_COMMUNITY,
        title: 'Unique and Largest Fintech Community',
        titleColor: '#cf7600',
        description:
          'Connect with a Passionate Audience, From Decision-Makers to Market Followers.'
      },
      {
        icon: ICON.DUAL_FOCUS,
        title: 'Dual Focus',
        titleColor: '#c100cf',
        description:
          'Tailored Strategies for B2B and B2C Markets, Addressing Unique Needs and Opportunities.'
      },
      {
        icon: ICON.ADVERTISING_SOLUTIONS,
        title: 'Customized Advertising Solutions',
        titleColor: '#00a22c',
        description:
          'Crafted to Meet Your Specific Goals, Whether in B2B, B2C, or Both.'
      },
      {
        icon: ICON.GLOBAL_RESEARCH,
        title: 'Global Reach with Local Relevance',
        titleColor: '#0044d4',
        description:
          'Expand Your Influence, Understanding Both Corporate and Consumer Dynamics Across Various Geographies.'
      }
    ]
  }
}
</script>

<style lang="scss" scoped>
@import '~assets/scss/local/mixins/grid';

$icon-size: (
  $above-desktop-xl: 101px,
  $desktop-sm: 45px
);

.why-us-section__list {
  $margin-top: (
    $above-desktop-xl: 50px,
    $desktop-sm: 43px,
    $mobile: 35px
  );

  $grid-setup: (
    $columnSetup: (
      $above-desktop-xl: 50% percentage(578px / $desktop-full-hd-container),
      $desktop-sm: 1fr 1fr,
      $mobile: 100%
    ),
    $columnGapSetup: (
      $above-desktop-xl: 40px,
      $desktop-sm: 16px
    )
  );

  @include gridBuilder($grid-setup);
  @include setStyleByBreakpoint('margin-top', $margin-top);
}

.why-us-section__item {
  $margin-bottom: (
    $above-desktop-xl: 25px,
    $desktop-sm: 36px,
    $mobile: 21px
  );

  $grid-setup: (
    $columnSetup: (
      $above-desktop-xl: map-get($icon-size, $above-desktop-xl) auto,
      $desktop-sm: map-get($icon-size, $desktop-sm) auto
    ),
    $columnGapSetup: (
      $above-desktop-xl: 25px,
      $desktop-sm: 8px
    )
  );

  @include gridBuilder($grid-setup);
  @include setStyleByBreakpoint('margin-bottom', $margin-bottom);
}

.why-us-section__item-logo {
  $width: (
    $above-desktop-xl: map-get($icon-size, $above-desktop-xl),
    $desktop-sm: map-get($icon-size, $desktop-sm)
  );

  $height: (
    $above-desktop-xl: map-get($icon-size, $above-desktop-xl),
    $desktop-sm: map-get($icon-size, $desktop-sm)
  );

  @include setStyleByBreakpoint('width', $width);
  @include setStyleByBreakpoint('height', $height);
}

.why-us-section__item-info {
  display: flex;
  flex-direction: column;
}

.why-us-section__item-description {
  margin-top: 7px;

  $min-height: (
    $above-desktop-xl: 92px,
    $desktop-sm: 53px,
    $mobile: auto
  );

  @include setStyleByBreakpoint('min-height', $min-height);
}
</style>
